export default "__VITE_ASSET__CyYlZayI__"